<template>
  <div>
    <el-col :span="18">
      <el-input v-model="tipsDetail" :disabled="true"></el-input>
    </el-col>
    <el-col :span="4">
      <el-button type="text" style="margin-left: 10px" @click="handleOpenEdit">
        <el-icon class="el-icon-edit"></el-icon>编辑
      </el-button>
      <el-button type="text" @click="handleClean">
        <el-icon class="el-icon-delete"></el-icon>清空
      </el-button>
    </el-col>
    <el-dialog
      :visible.sync="showDialog"
      top="5vh"
      width="60%"
      title="编辑落地页提示"
      append-to-body
      destroy-on-close
    >
      <el-form ref="form" class="dialog-form" :model="form" label-width="80px" label-position="left">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="场景">
              <el-select filterable v-model="form.screenType">
                <el-option key="full" value="full" label="全屏"></el-option>
                <el-option key="mini" value="mini" label="小屏"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="开始时间"
              prop="show_time"
              :rules="[
                { required: true, message: '必须填写', trigger: 'blur' },
                { type: 'number', message: '开始时间必须为数字值', trigger: 'blur' }
              ]"
            >
              <el-input
                v-model.number="form.show_time"
                :min="-1"
                :max="form.end_time"
                :step="1"
                placeholder="开始时间"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="结束时间"
              prop="end_time"
              :rules="[
                { required: true, message: '必须填写', trigger: 'blur' },
                { type: 'number', message: '结束时间必须为数字值', trigger: 'blur' }
              ]"
            >
              <el-input
                v-model.number="form.end_time"
                placeholder="结束时间"
                :min="form.show_time"
                :step="1"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="位置">
              <el-select filterable v-model="form.locationType">
                <el-option key="locationType1" :value="1" label="上左"></el-option>
                <el-option key="locationType2" :value="2" label="上中"></el-option>
                <el-option key="locationType3" :value="3" label="上右"></el-option>
                <el-option key="locationType4" :value="4" label="中左"></el-option>
                <el-option key="locationType5" :value="5" label="居中"></el-option>
                <el-option key="locationType6" :value="6" label="中右"></el-option>
                <el-option key="locationType7" :value="7" label="下左"></el-option>
                <el-option key="locationType8" :value="8" label="下中"></el-option>
                <el-option key="locationType9" :value="9" label="下右"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="上下边距"
              prop="marginY"
              :rules="[
                { required: true, message: '必须填写', trigger: 'blur' },
                { type: 'number', message: '必须为数字值', trigger: 'blur' }
              ]"
            >
              <el-input
                type="number"
                v-model.number="form.marginY"
                :step="1"
                :min="0"
                placeholder="上下"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="左右边距"
              prop="marginX"
              :rules="[
                { required: true, message: '必须填写', trigger: 'blur' },
                { type: 'number', message: '必须为数字值', trigger: 'blur' }
              ]"
            >
              <el-input
                type="number"
                v-model.number="form.marginX"
                :step="1"
                :min="0"
                placeholder="左右"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="类型">
              <el-select filterable v-model="form.type">
                <el-option key="type1" value="txt" label="文字"></el-option>
                <el-option key="type2" value="image" label="图片"></el-option>
                <el-option key="type3" value="qrcode" label="二维码"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type === 'txt'" :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="文案"
              prop="content"
              :rules="[{ required: true, message: '请输入文案', trigger: 'blur' }]"
            >
              <el-input v-model.trim="form.content" placeholder="提示语文案"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="字号">
              <el-select filterable v-model="form.fontSize">
                <el-option key="fontSize1" :value="16" :label="16"></el-option>
                <el-option key="fontSize2" :value="18" :label="18"></el-option>
                <el-option key="fontSize3" :value="20" :label="20"></el-option>
                <el-option key="fontSize4" :value="22" :label="22"></el-option>
                <el-option key="fontSize5" :value="24" :label="24"></el-option>
                <el-option key="fontSize6" :value="26" :label="26"></el-option>
                <el-option key="fontSize7" :value="28" :label="28"></el-option>
                <el-option key="fontSize8" :value="30" :label="30"></el-option>
                <el-option key="fontSize9" :value="32" :label="32"></el-option>
                <el-option key="fontSize10" :value="36" :label="36"></el-option>
                <el-option key="fontSize11" :value="48" :label="48"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-else :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="地址"
              prop="content"
              :rules="{
                required: true,
                message: '必须填写',
                trigger: 'blur'
              }"
            >
              <el-input v-model="form.content" placeholder="请填写地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="宽度"
              prop="width"
              :rules="[
                { required: true, message: '必须填写', trigger: 'blur' },
                { type: 'number', message: '必须为数字值', trigger: 'blur' }
              ]"
            >
              <el-input
                type="number"
                :step="1"
                :min="0"
                v-model.number="form.width"
                placeholder="宽度"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="高度"
              prop="height"
              :rules="[
                { required: true, message: '必须填写', trigger: 'blur' },
                { type: 'number', message: '必须为数字值', trigger: 'blur' }
              ]"
            >
              <el-input
                type="number"
                :step="1"
                :min="0"
                v-model.number="form.height"
                placeholder="高度"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    initTipsDetail: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tipsDetail: this.initTipsDetail,
      showDialog: false,
      form: this.genForm()
    }
  },
  watch: {
    initTipsDetail: {
      handler(newVal) {
        this.tipsDetail = newVal
      }
    }
  },
  methods: {
    genForm() {
      return {
        content: undefined,
        end_time: undefined,
        fontSize: undefined,
        height: undefined,
        locationType: 1,
        marginX: undefined,
        marginY: undefined,
        screenType: 'full',
        show_time: undefined,
        type: 'txt',
        width: undefined
      }
    },
    handleCancel() {
      this.showDialog = false
    },
    async handleSubmit() {
      const isValid = await this.$refs.form.validate().catch(() => {})
      if (isValid) {
        this.tipsDetail = JSON.stringify(this.form)
        this.$emit('tips-change', this.tipsDetail)
        this.showDialog = false
      }
    },
    handleOpenEdit() {
      if (this.tipsDetail === '') {
        this.form = this.genForm()
        this.showDialog = true
        return
      }
      const tipsObj = JSON.parse(this.tipsDetail)
      this.form = {
        ...this.genForm(),
        ...tipsObj
      }
      this.showDialog = true
    },
    handleClean() {
      this.tipsDetail = ''
      this.$emit('tips-change', '')
    }
  }
}
</script>

<style lang="stylus" scoped>
.dialog-form
  padding 20px
  .el-select
    width 100%
</style>
